export enum SystemNotificationType {
  FIGHT_OFFER_PRIVATE_SENT = "FIGHT_OFFER_PRIVATE_SENT",
  FIGHT_OFFER_PRIVATE_COUNTERED = "FIGHT_OFFER_PRIVATE_COUNTERED",
  FIGHT_OFFER_PRIVATE_ACCEPTED = "FIGHT_OFFER_PRIVATE_ACCEPTED",
  FIGHT_OFFER_PRIVATE_DECLINED = "FIGHT_OFFER_PRIVATE_DECLINED",
  FIGHT_OFFER_PUBLIC_APPLICATION_RECEIVED = "FIGHT_OFFER_PUBLIC_APPLICATION_RECEIVED",
  FIGHT_OFFER_PUBLIC_UPDATED = "FIGHT_OFFER_PUBLIC_UPDATED",
  VERIFICATION_STATUS_UPDATED = "VERIFICATION_STATUS_UPDATED",
  ADMIN_VERIFICATION_REQUEST_SUBMITTED = "ADMIN_VERIFICATION_REQUEST_SUBMITTED",
  CLAIM_STATUS_UPDATED = "CLAIM_STATUS_UPDATED",
  ADMIN_CLAIM_REQUEST_SUBMITTED = "ADMIN_CLAIM_REQUEST_SUBMITTED",
  ADMIN_USER_FEEDBACK_SUBMITTED = "ADMIN_USER_FEEDBACK_SUBMITTED",
  ADMIN_PROFILE_REPORT_SUBMITTED = "ADMIN_PROFILE_REPORT_SUBMITTED",
  FIGHT_OFFER_CLOSED = "FIGHT_OFFER_CLOSED",
  EVENT_REGISTRATION_SUBMITTED = "EVENT_REGISTRATION_SUBMITTED",
  EVENT_REGISTRATION_ACCEPTED = "EVENT_REGISTRATION_ACCEPTED",
  EVENT_REGISTRATION_REJECTED = "EVENT_REGISTRATION_REJECTED",
  EVENT_CANCELED = "EVENT_CANCELED",
  EVENT_FIGHT_CARD_ASSIGNED = "EVENT_FIGHT_CARD_ASSIGNED",
  EVENT_FIGHT_CARD_UPDATED = "EVENT_FIGHT_CARD_UPDATED",
  EVENT_REGISTRATION_REMOVED = "EVENT_REGISTRATION_REMOVED",
  EVENT_TOURNAMENT_MATCH_ASSIGNED = "EVENT_TOURNAMENT_MATCH_ASSIGNED",
  EVENT_TOURNAMENT_MATCH_UPDATED = "EVENT_TOURNAMENT_MATCH_UPDATED",
  EVENT_TOURNAMENT_ADVANCED = "EVENT_TOURNAMENT_ADVANCED",
}

export type SystemNotification = {
  id: string;
  created_at: string;
  recipient_user_id: string;
  type: SystemNotificationType;
  translation_key: string;
  translation_params: Record<string, unknown>;
  action_path: string | null;
  read_at: string | null;
  actor_entity_id: string | null;
  target_entity_id: string | null;
  source_type: string | null;
  source_id: string | null;
  metadata: Record<string, unknown>;
  idempotency_key: string | null;
};
